import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";

const transcriptsSchema = z
  .object({
    org_id: z.string(),
    channel_response: z.array(
      z.object({
        companies: z
          .array(
            z.object({
              company_name: z.string(),
              relation_id: z.string(),
            }),
          )
          .nullable(),
        type: z.string(),
        title: z.string(),
        file_id: z.string(),
        meeting_date: z.string(),
        sentiment: z.string(),
        attendees: z.array(
          z.object({
            name: z.string(),
            company: z.string().optional(), // allows missing company
          }),
        ),
        call_type: z.string(),
        recording_share_url: z.string().nullable().optional(),
      }),
    ),
  })
  .nullable();
export type TranscriptsSchema = z.infer<typeof transcriptsSchema>;

const transcriptsResponseSchema = z.object({
  response: z
    .array(
      z.object({
        companies: z
          .array(
            z.object({
              company_name: z.string(),
              relation_id: z.string(),
            }),
          )
          .nullable(),
        type: z.string(),
        title: z.string(),
        file_id: z.string(),
        content: z.string(),
        sentiment: z.string().optional(),
        attendees: z
          .array(
            z.object({
              name: z.string(),
              company: z.string().optional(), // allows missing company
            }),
          )
          .optional(),
        call_type: z.string().optional(),
        recording_share_url: z.string().nullable().optional(),
      }),
    )
    .nullable(),
});

const builder = apiBuilder()
  .addEndpoint({
    alias: "getTranscripts",
    method: "get",

    path: "/organizations/:org_id?relation_id=:relation_id",
    status: 200,
    parameters: [
      {
        name: "org_id",
        type: "Path",
        schema: z.string(),
        description: "Organization ID",
      },
      {
        name: "relation_id",
        type: "Query",
        schema: z.string().optional(),
        description: "Relation ID",
      },
    ],
    response: transcriptsSchema,
  })
  .addEndpoint({
    alias: "getTranscriptsResponse",
    method: "get",
    path: "/organizations/:org_id/:file_id",
    status: 200,
    parameters: [
      {
        name: "org_id",
        type: "Path",
        schema: z.string(),
        description: "Organization ID",
      },
      {
        name: "file_id",
        type: "Path",
        schema: z.string(),
        description: "File ID",
      },
    ],
    response: transcriptsResponseSchema,
  });

export const transcriptApiDefinitions = prefixApi("/clio", builder.build());
